import React from 'react';
import { colors, spacing, typography } from '../../../design-system/index.js';

export const SocialStrip = () => {
  const sectionStyles = {
    padding: `${spacing[12]} 0`,
    borderBottom: `1px solid ${colors.border.light}`,
  };

  const socialListStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing[8],
    listStyle: 'none',
    margin: 0,
    padding: 0,
    flexWrap: 'wrap',
  };

  const socialItemStyles = {
    transition: 'all 0.3s ease',
  };

  const socialLinkStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: spacing[2],
    padding: `${spacing[3]} ${spacing[4]}`,
    borderRadius: spacing.borderRadius.full,
    backgroundColor: 'transparent',
    border: `1px solid ${colors.border.default}`,
    color: colors.text.primary,
    textDecoration: 'none',
    fontSize: typography.fontSize.sm,
    fontWeight: typography.fontWeight.normal,
    transition: 'all 0.3s ease',
    cursor: 'pointer',
  };

  const socialLinkHoverStyles = {
    backgroundColor: colors.background.secondary,
    borderColor: colors.text.primary,
    transform: 'translateY(-2px)',
  };

  const iconStyles = {
    width: '18px',
    height: '18px',
    backgroundColor: colors.text.primary,
    borderRadius: '2px',
    flexShrink: 0,
  };

  const socialLinks = [
    { name: 'GitHub', url: '#', icon: '🔗' },
    { name: 'X (Twitter)', url: '#', icon: '🐦' },
    { name: 'LinkedIn', url: '#', icon: '💼' },
    { name: 'Email', url: '#', icon: '✉️' },
    { name: 'Blog', url: '#', icon: '📝' },
  ];

  const handleMouseEnter = (e) => {
    Object.assign(e.target.style, socialLinkHoverStyles);
  };

  const handleMouseLeave = (e) => {
    e.target.style.backgroundColor = 'transparent';
    e.target.style.borderColor = colors.border.default;
    e.target.style.transform = 'translateY(0)';
  };

  return (
    <section style={sectionStyles} className="social-strip">
      <ul style={socialListStyles} className="social-icons">
        {socialLinks.map((social, index) => (
          <li key={social.name} style={socialItemStyles}>
            <a
              href={social.url}
              style={socialLinkStyles}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              aria-label={social.name}
            >
              <div style={iconStyles} title={social.icon} />
              <span>{social.name}</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};
